const isDevelopment = window.location.hostname === "localhost";

export const config = {
  googleMapsApiKey: "AIzaSyCcZ22W5-Xhznx8sAAZ4_uotbIH_7Gdjsg",
  logoSrc: "/header-logo.png",
  flightSiteName: "Hello Near Me",
  hotelSiteName: "Hello Near Me",
  primaryColorBg: "bg-[#6d16f5]",
  primaryColorText: "text-[#6d16f5]",
  primaryColorRing: "ring-[#6d16f5]",
  backendServer: isDevelopment
    ? "http://localhost:5000"
    : "https://hello-near-me.onrender.com",
  socialLinks: {
    linkedin: "https://www.linkedin.com/company/hellonearme ",
    facebook: "https://facebook.com/",
    twitter: "https://x.com/hellonearme_",
    instagram: "https://instagram.com/",
  },
  companyInfo: {
    name: "Hello Near Me",
    copyright: "© 2025 All rights reserved",
  },
  supportInfo: {
    phone: "Not available",
    email: "info@hellonearme.com",
  },
  pricing: {
    markupType: "percentage",
    markupValue: 2,
  },
  hotelPricing: {
    markupType: "percentage",
    markupValue: 5,
  },
};
